import { IAppState } from '../../types/redux';

export function selectRecommendations(state: IAppState) {
  return state.recommendations.data;
}

export const selectRecommendationById = (id: number | null) => (state: IAppState) =>
  state.recommendations.data.find(({ offerId }) => offerId === id) || null;

export function selectRecommendationsStatus(state: IAppState) {
  return state.recommendations.status;
}

export function selectRecommendationsHasRequested(state: IAppState) {
  return state.recommendations.hasRequested;
}

export function selectHasMore(state: IAppState) {
  return state.recommendations.hasMore;
}

export function selectPaginationStatus(state: IAppState) {
  return state.recommendations.paginationStatus;
}
